import { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import equal from 'fast-deep-equal';

import { Button } from 'UIPackage/MainModule/components/Button';
import { PublishRulesTree } from 'PublishRulesPackage/MainModule/components/PublishRulesTree';
import { PublishRulesTreeContent } from 'PublishRulesPackage/MainModule/components/PublishRulesTreeContent';
import { PUBLISH_RULES_FORM_ID } from 'PublishRulesPackage/MainModule/constants/publishRulesFieldsElementsIds';
import { PublishRulesFormRef } from 'PublishRulesPackage/MainModule/reducers/publishRulesReducer';
import {
  getPublishRulesActiveTreeItem,
  getPublishRulesFormRef,
} from 'PublishRulesPackage/MainModule/selectors/publishRulesSelectors';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { fetchPublishRulesSavedSettingsCategories } from 'PublishRulesPackage/MainModule/actions/publishRulesActions';
import { IPublishRulesTreeItem } from 'PublishRulesPackage/MainModule/interfaces/IPublishRulesTreeItem';

import styles from './PublishRulesPage.module.scss';

interface IPublishRulesPageProps {
  formRef?: PublishRulesFormRef;
  activeTreeItem: IPublishRulesTreeItem;
}

const PublishRulesPageWithoutStore = ({ formRef, activeTreeItem }: IPublishRulesPageProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();

  useEffect(() => {
    dispatch(fetchPublishRulesSavedSettingsCategories());
  }, []);

  const submitForm = () => {
    document?.getElementById(PUBLISH_RULES_FORM_ID)?.dispatchEvent(new Event('submit', { cancelable: true }));
  };

  const [isFormDirty, setIsFormDirty] = useState(false);
  const [isFormPristine, setIsFormPristine] = useState(true);
  const [isValid, setIsValid] = useState<boolean>();

  // Подписка на состояния формы
  useEffect(() => {
    if (!formRef?.current) return;
    const unsubscribe = formRef.current.subscribe(
      ({ dirty, values, initialValues, valid }) => {
        setIsFormDirty(dirty);
        setIsFormPristine(equal(values, initialValues));
        setIsValid(valid);
      },
      { dirty: true, values: true, initialValues: true, valid: true },
    );

    return () => {
      unsubscribe?.();
    };
  }, [formRef]);

  return (
    <div className={styles.Wrapper}>
      <div className={styles.Header}>
        <h1 className={styles.Title}>Настройка правил публикации</h1>
        <div>
          <Button
            disabled={!isValid || (!activeTreeItem?.haveSavedSettings ? false : !isFormDirty || isFormPristine)}
            color="primary"
            text="Сохранить"
            id="saveButton"
            type="submit"
            onClick={submitForm}
          />
        </div>
      </div>
      <div className={styles.ContentWrapper}>
        <PublishRulesTree />
        <PublishRulesTreeContent />
      </div>
    </div>
  );
};

const mapStateToProps = (state: IRootState) => ({
  activeTreeItem: getPublishRulesActiveTreeItem(state),
  formRef: getPublishRulesFormRef(state),
});

export const PublishRulesPage = connect(mapStateToProps)(PublishRulesPageWithoutStore);
